<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('translationOrder') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'translationList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('translationList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-stepper
        v-model="e1"
        flat
      >
        <v-stepper-header style="height: 40px;">
          <v-stepper-step
            :complete="e1 > 1"
            step="1"
            editable
          >
            {{ $t('customer') }}
          </v-stepper-step>

          <v-divider />

          <v-stepper-step
            :complete="e1 > 2"
            step="2"
            editable
          >
            {{ $t('translateDocuments') }}
          </v-stepper-step>

          <v-divider />

          <v-stepper-step
            step="3"
            editable
          >
            {{ $t('receiveCash') }}
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content
            class="px-2"
            step="1"
          >
            <v-container>
              <v-row class="mb-4 mx-0">
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="3"
                  sm="3"
                >
                  <autocomplete
                    v-model="customer"
                    title="customer"
                    type="person"
                    :new-btn="true"
                    :value="customer"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="ps-0"
                  sm="2"
                  md="2"
                >
                  <v-text-field
                    v-model="number"
                    height="20"
                    dense
                    :rules="[v => !!v || $t('is-required')]"
                    outlined
                    class="mb-3 dense"
                    clearable
                    type="number"
                    :label="$t('number')"
                    @blur="getTranslatorNumber"
                  />
                </v-col>
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="2"
                  sm="2"
                >
                  <autocomplete
                    v-model="languageGroup"
                    title="languageGroup"
                    type="translationLanguage"
                    :new-btn="true"
                    :value="languageGroup"
                  />
                </v-col>
                <v-col
                  cols="12"
                  class="ps-0"
                  md="2"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  sm="2"
                >
                  <template>
                    <v-text-field
                      id="from"
                      v-model="date"
                      :label="$t('date')"
                      :rules="[v => !!v || $t('is-required')]"
                      clear-icon="flaticon2-close-cross"
                      outlined
                      dense
                      clearable
                    />
                    <date-picker
                      v-model="date"
                      element="from"
                      :locale="$store.state.date_locale"
                      :format="$store.state.date_format"
                      auto-submit
                      :min="$store.state.startDate"
                      :max="$store.state.endDate"
                      :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                      @close="setDate"
                    />
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="ps-0"
                  sm="2"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                >
                  <template>
                    <v-text-field
                      id="deliveryDateId"
                      v-model="deliveryDate"
                      :label="$t('deliveryDate')"
                      clear-icon="flaticon2-close-cross"
                      outlined
                      dense
                      clearable
                      @keyup="deliveryDate = null"
                    />

                    <date-picker
                      v-model="deliveryDate"
                      element="deliveryDateId"
                      :locale="$store.state.date_locale"
                      :format="$store.state.date_format"
                      auto-submit
                      :min="deliveryDate"
                      :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                      @close="setDate"
                    />
                  </template>
                </v-col>
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="3"
                  sm="3"
                >
                  <autocomplete
                    v-model="translator"
                    title="translator"
                    type="person"
                    :new-btn="true"
                    :data="JSON.stringify({type: 'translator'})"
                    :value="translator"
                  />
                </v-col>
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="4"
                  sm="4"
                >
                  <status
                    v-model="status"
                    :hideconfig="true"
                    type="translation"
                    :value="status"
                  />
                </v-col>
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="4"
                  sm="4"
                >
                  <tag
                    v-model="tag"
                    :solo="false"
                    :input="tag"
                    :height="25"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-0 mx-0">
                <p>
                  {{ $t('non-translateDocuments') }}
                </p>
                <v-divider class="mt-3 ms-2" />
              </v-row>
              <v-row class="mb-4 mx-0">
                <v-col
                  class="xs ps-0"
                  cols="12"
                  :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                  md="3"
                  sm="3"
                >
                  <autocomplete
                    v-model="documentOwner"
                    title="documentOwner"
                    type="person"
                    :new-btn="true"
                    :value="documentOwner"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="ps-0"
                >
                  <aicomplete
                    v-model="nontranslateDocument"
                    title="non-translateDocuments"
                    type="nontranslateDocument"
                    :new-btn="true"
                    :val="nontranslateDocument"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="ps-0"
                >
                  <description
                    v-model="nontranslateDocumentContent"
                    :outlined="true"
                    type="sell"
                    :value="nontranslateDocumentContent"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        icon
                        v-bind="attrs"
                        class="ms-2"
                        v-on="on"
                        @click="addAttachment"
                      >
                        <v-icon
                          color="primary"
                          style="font-size: 30px"
                        >
                          mdi-plus-box
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('add') }}</span>
                  </v-tooltip>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>
                            {{ $t('row') }}
                          </th>
                          <th>
                            {{ $t('name') }}
                          </th>
                          <th>
                            {{ $t('content') }}
                          </th>
                          <th>
                            #
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, key) in nontranslateDocumentItems"
                          :key="key"
                        >
                          <td>{{ parseFloat(key)+parseFloat(1) }}</td>
                          <td>{{ (item.nontranslateDocument ? item.nontranslateDocument.name : '') }}</td>
                          <td>{{ item.content }}</td>
                          <td>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="pink"
                                  icon
                                  small
                                  v-bind="attrs"
                                  class="ms-2"
                                  v-on="on"
                                  @click="removeAttachment(key)"
                                >
                                  <v-icon
                                    color="pink"
                                    style="font-size: 22px"
                                  >
                                    mdi-close-box
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('remove') }}</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-content
            class="px-2 pt-2"
            step="2"
          >
            <v-container>
              <v-form
                ref="formStep2"
                v-model="validStep2"
                lazy-validation
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-row class="mb-4">
                      <v-col
                        class="xs ps-0"
                        cols="12"
                        :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                        md="4"
                        sm="4"
                      >
                        <aicomplete
                          v-model="documentType"
                          title="documentType"
                          type="setConfig"
                          :new-btn="true"
                          :data="JSON.stringify({key:'t_docuemtnType', type:'translation'})"
                          :val="documentType"
                        />
                      </v-col>
                      <v-col
                        class="xs ps-0"
                        cols="12"
                        :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          v-model="fromLanguage"
                          title="fromLanguage"
                          type="setConfig"
                          :new-btn="true"
                          :data="JSON.stringify({key:'t_languages', type:'translation'})"
                          :val="fromLanguage"
                        />
                      </v-col>
                      <v-col
                        class="xs ps-0"
                        cols="12"
                        :class="{'mb-3' : $vuetify.breakpoint.mobile}"
                        md="3"
                        sm="3"
                      >
                        <aicomplete
                          v-model="toLanguage"
                          title="toLanguage"
                          type="setConfig"
                          :new-btn="true"
                          :data="JSON.stringify({key:'t_languages', type:'translation'})"
                          :val="toLanguage"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="ps-0"
                        sm="2"
                        md="2"
                      >
                        <v-text-field
                          v-model="documentCount"
                          height="20"
                          dense
                          type="number"
                          :rules="[v => !!v || $t('is-required')]"
                          outlined
                          class="mb-3 dense"
                          clearable
                          :label="$t('documentCount')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        class="ps-0"
                        sm="4"
                        md="4"
                      >
                        <v-text-field
                          v-model="customerTitle"
                          height="20"
                          dense
                          :rules="[v => !!v || $t('is-required')]"
                          outlined
                          class="mb-3 dense"
                          clearable
                          :label="$t('customerTitle')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="8"
                        class="ps-0"
                      >
                        <description
                          v-model="customertContent"
                          :outlined="true"
                          type="sell"
                          :value="customertContent"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <p>
                        {{ $t('Number_version_urgency') }}
                      </p>
                      <v-divider class="mt-3 mx-2" />
                    </v-row>
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="12"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-text-field
                          v-model="baseCount"
                          height="20"
                          min="0"
                          hide-details
                          type="number"
                          dense
                          outlined
                          class="mb-3 dense"
                          clearable
                          :label="$t('baseCount')"
                          :rules="exampleRules"
                          @focus="focusEvent"
                        />
                        <v-text-field
                          v-model="addDocumentCount"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="mb-3 dense ms-1"
                          clearable
                          :label="$t('addDocumentCount')"
                          type="number"
                          @focus="focusEvent"
                        />
                        <v-text-field
                          v-model="percentDocumentCount"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="mb-3 dense ms-1"
                          clearable
                          :label="$t('percentDocumentCount')"
                          type="number"
                          :rules="exampleRules"
                          @focus="focusEvent"
                        />
                        <v-text-field
                          v-model="countSpecialTranslat"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="mb-3 dense ms-1"
                          clearable
                          :label="$t('countSpecialTranslat')"
                          type="number"
                          @focus="focusEvent"
                        />
                        <v-text-field
                          v-model="countSpecialTranslatAdditional"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="mb-3 dense ms-1"
                          clearable
                          :label="$t('countSpecialTranslatAdditional')"
                          type="number"
                          @focus="focusEvent"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <p>
                        {{ $t('typeTranslation&approval') }}
                      </p>
                      <v-divider class="mt-3 mx-2" />
                    </v-row>
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0"
                      >
                        <v-checkbox
                          v-model="unofficial"
                          :label="$t('unofficial')"
                          color="indigo"
                          value="active"
                          class="mt-0"
                          :disabled="(judicialApproval || foreignApproval || stampTranslator ? true : false)"
                          hide-details
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="judicialApproval"
                          :label="$t('judicialApproval')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          :disabled="(unofficial ? true : false)"
                          hide-details
                        />
                        <v-text-field
                          v-model="judicialApprovalCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!judicialApproval"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="foreignApproval"
                          :label="$t('foreignApproval')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          :disabled="(unofficial ? true : false)"
                          hide-details
                        />
                        <v-text-field
                          v-model="foreignApprovalCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!foreignApproval"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="stampTranslator"
                          :label="$t('stampTranslator')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          :disabled="(unofficial ? true : false)"
                          hide-details
                        />
                        <v-text-field
                          v-model="stampTranslatorCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!stampTranslator"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="officeServices"
                          :label="$t('officeServices')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          hide-details
                        />
                        <v-text-field
                          v-model="officeServicesCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :value="parseFloat(baseCount) + parseFloat(addDocumentCount)"
                          :disabled="!officeServices"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="verificationServices"
                          :label="$t('verificationServices')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          :disabled="(unofficial ? true : false)"
                          hide-details
                        />
                        <v-text-field
                          v-model="verificationServicesCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!verificationServices"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="equalOriginal"
                          :label="$t('equalOriginal')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          :disabled="(unofficial ? true : false)"
                          hide-details
                        />
                        <v-text-field
                          v-model="equalOriginalCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!equalOriginal"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="ps-0 pt-0 d-flex"
                      >
                        <v-checkbox
                          v-model="embassy"
                          :label="$t('embassy')"
                          color="indigo"
                          class="mt-0"
                          value="active"
                          hide-details
                          :disabled="(unofficial ? true : false)"
                        />
                        <v-text-field
                          v-model="embassyCount"
                          height="20"
                          hide-details
                          type="number"
                          style="max-width: 60px"
                          dense
                          outlined
                          :disabled="!embassy"
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        v-show="embassy"
                        cols="12"
                        md="3"
                        class="ps-0 pt-0"
                      >
                        <v-text-field
                          v-model="embassyName"
                          :label="$t('embassyName')"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="dense mx-1"
                        />
                      </v-col>
                      <v-col
                        v-show="embassy"
                        cols="12"
                        md="3"
                        class="ps-0 pt-0"
                      >
                        <v-text-field
                          v-model="embassyCost"
                          :label="$t('embassyCost')"
                          height="20"
                          hide-details
                          dense
                          outlined
                          class="mb-3 dense ms-1"
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="6"
                        class="px-1"
                      >
                        <v-btn
                          :color="(editStatus ? 'blue': 'green')"
                          class="mr-0"
                          @click="addItem"
                        >
                          {{ (editStatus ? $t('edit'): $t('addToOrder')) }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="pt-0"
                  >
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="12"
                        class="ps-0 mt-2 pt-0"
                      >
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center invoice-1"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('baseTranslate') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('addDocument') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('specialTranslat') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('specialTranslatAdditional') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ $t('fee') }}</td>
                                <td>
                                  <money
                                    v-model="basePrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="addDocumentPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    :disabled="true"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="specialTranslatPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="specialTranslatAddPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    :disabled="true"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>{{ $t('total') }}</td>
                                <td>{{ (basePriceTotal ? $numberFormat(basePriceTotal) : 0) }}</td>
                                <td>{{ (addDocumentPriceTotal ? $numberFormat(addDocumentPriceTotal) : 0) }}</td>
                                <td>{{ (specialTranslatTotal ? $numberFormat(specialTranslatTotal) : 0) }}</td>
                                <td>{{ (specialTranslatAddPriceTotal ? $numberFormat(specialTranslatAddPriceTotal) : 0) }}</td>
                              </tr>
                              <tr>
                                <td colspan="3">
                                  <money
                                    v-model="urgentAmount"
                                    :label="$t('urgentAmount')"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense ms-1"
                                  />
                                </td>
                                <td colspan="2">
                                  <money
                                    v-model="discountTranslate"
                                    :dense="true"
                                    :label="$t('discountTranslate')"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td />
                                <td />
                                <td />
                                <td colspan="2">
                                  <money
                                    v-model="discountService"
                                    :dense="true"
                                    :label="$t('discountService')"
                                    :outlined="true"
                                    :solo="false"
                                    :clearable="true"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-2"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('stampTranslator') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('judicialApproval') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('officeServices') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('equalOriginal') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ $t('fee') }}</td>
                                <td>
                                  <money
                                    v-model="stampTranslatorPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="judicialApprovalPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="officeServicesPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="equalOriginalPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>{{ $t('total') }}</td>
                                <td>{{ (stampTranslator && stampTranslatorCount ? $numberFormat(stampTranslatorPrice*stampTranslatorCount) : 0) }}</td>
                                <td>{{ (judicialApproval && judicialApprovalCount ? $numberFormat(judicialApprovalPrice*judicialApprovalCount) : 0) }}</td>
                                <td>{{ (officeServices && officeServicesCount ? $numberFormat(officeServicesPrice*officeServicesCount) : 0) }}</td>
                                <td>{{ (equalOriginal && equalOriginalCount ? $numberFormat(equalOriginalPrice*equalOriginalCount) : 0) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-2"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('foreignApproval') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('verificationServices') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('embassy') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ $t('fee') }}</td>
                                <td>
                                  <money
                                    v-model="foreignApprovalPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="verificationServicesPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                                <td>
                                  <money
                                    v-model="embassyPrice"
                                    :dense="true"
                                    :outlined="true"
                                    :solo="false"
                                    value-when-is-empty=""
                                    :options="options"
                                    class="mb-4 mt-2 dense"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>{{ $t('total') }}</td>
                                <td>{{ (foreignApproval && foreignApprovalCount ? $numberFormat(foreignApprovalPrice*foreignApprovalCount) : 0) }}</td>
                                <td>{{ (verificationServices && verificationServicesCount ? $numberFormat(verificationServicesPrice*verificationServicesCount) : 0) }}</td>
                                <td>{{ (embassy && embassyCount ? $numberFormat(embassyPrice*embassyCount) : 0) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-3"
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td>{{ $t('totalStamp&Approval') }}</td>
                                <td>{{ $numberFormat(totalStamp) }}</td>
                                <td>{{ $t('totalCost') }}</td>
                                <td>{{ $numberFormat(totalCost) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <p>
                    {{ $t('translationItems') }}
                  </p>
                  <v-divider class="mt-3 mx-2" />
                </v-row>
              </v-form>
              <v-row class="mt-0">
                <order-item
                  :items="items"
                  @edit="editItem"
                  @remove="removeItem"
                />
              </v-row>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-container>
              <v-form
                ref="formStep3"
                v-model="validStep3"
                lazy-validation
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                    class="pt-1"
                  >
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="6"
                        class="px-0 pt-0"
                      >
                        <v-btn
                          color="green"
                          outlined
                          small
                          class="ms-0"
                          @click="openComponent('payment', customer, 'recieve')"
                        >
                          {{ $t('cashReceive') }}
                        </v-btn>
                        <v-btn
                          color="purple"
                          outlined
                          small
                          class="ms-2"
                          @click="openComponent('check', customer, 'recieveCheck')"
                        >
                          {{ $t('recieveCheck') }}
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        class="ps-0 mt-2 mb-8 pt-0"
                      >
                        <p class="mb-1">
                          {{ $t('cashReceiveList') }}
                        </p>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('payer') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('amount') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('date') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('bank') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('currency') }}
                                </th>
                                <th class="text-center" />
                              </tr>
                            </thead>
                            <tbody
                              v-for="(item, i) in recieves"
                              :key="i"
                            >
                              <tr>
                                <td>{{ +i + 1 }}</td>
                                <td>{{ item.account.name }}</td>
                                <td>{{ $numberFormat(item.amount) }}</td>
                                <td>{{ item.date }}</td>
                                <td>{{ item.bank.name }}</td>
                                <td>{{ item.currency.name }}</td>
                                <td>
                                  <v-btn
                                    color="pink"
                                    outlined
                                    x-small
                                    class="ms-0"
                                    :loading="loading"
                                    @click="removeCash(i)"
                                  >
                                    {{ $t('remove') }}
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-col
                        cols="12"
                        class="ps-0 mt-2 pt-0"
                      >
                        <p class="mb-1">
                          {{ $t('recieveCheckList') }}
                        </p>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center"
                        >
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-center" />
                              <th class="text-center">
                                {{ $t('payer') }}
                              </th>
                              <th class="text-center">
                                {{ $t('amount') }}
                              </th>
                              <th class="text-center">
                                {{ $t('dueDate') }}
                              </th>
                              <th class="text-center">
                                {{ $t('date') + ' ' + $t('issue') }}
                              </th>
                              <th class="text-center">
                                {{ $t('bank') }}
                              </th>
                              <th class="text-center">
                                {{ $t('currency') }}
                              </th>
                              <th class="text-center" />
                            </tr>
                            </thead>
                            <tbody
                              v-for="(item, i) in checks"
                              :key="i"
                            >
                            <tr>
                              <td>{{ +i + 1 }}</td>
                              <td>{{ item.account.name }}</td>
                              <td>{{ $numberFormat(item.amount) }}</td>
                              <td>{{ item.dueDate }}</td>
                              <td>{{ item.date }}</td>
                              <td>{{ item.bankName }}</td>
                              <td>{{ item.currency.name }}</td>
                              <td>
                                <v-btn
                                  color="pink"
                                  outlined
                                  x-small
                                  class="ms-0"
                                  :loading="loading"
                                  @click="removeCheck(i)"
                                >
                                  {{ $t('remove') }}
                                </v-btn>
                              </td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="pt-0"
                  >
                    <v-row class="mb-4 my-0">
                      <v-col
                        cols="12"
                        class="ps-0 mt-2 pt-0"
                      >
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center invoice-1"
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td>{{ $t('totalTranslation') }}</td>
                                <td>{{ $numberFormat(+totals.basePriceTotal + +totals.addDocumentPriceTotal + +totals.specialTranslatTotal + +totals.specialTranslatAddPriceTotal) }}</td>
                                <td>{{ $t('urgentAmount') }}</td>
                                <td>{{ $numberFormat(totals.urgentAmount) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-1"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('stampTranslator') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('judicialApproval') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('officeServices') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('equalOriginal') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ $t('total') }}</td>
                                <td>{{ $numberFormat(totals.stampTranslatorPrice) }}</td>
                                <td>{{ $numberFormat(totals.judicialApprovalPrice) }}</td>
                                <td>{{ $numberFormat(totals.officeServicesPrice) }}</td>
                                <td>{{ $numberFormat(totals.equalOriginalPrice) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-1"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-center" />
                                <th class="text-center">
                                  {{ $t('foreignApproval') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('verificationServices') }}
                                </th>
                                <th class="text-center">
                                  {{ $t('embassy') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{{ $t('total') }}</td>
                                <td>{{ $numberFormat(totals.foreignApprovalPrice) }}</td>
                                <td>{{ $numberFormat(totals.verificationServicesPrice) }}</td>
                                <td>{{ $numberFormat(totals.embassyPrice) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-discount"
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td>{{ $t('discountTranslate') }}</td>
                                <td>{{ $numberFormat(totals.discountTranslate) }}</td>
                                <td>{{ $t('discountService') }}</td>
                                <td>{{ $numberFormat(totals.discountService) }}</td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                        <v-simple-table
                          dense
                          style="width:100%;"
                          class="text-center mt-1 invoice-3"
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <td>{{ $t('totalCost') }}</td>
                                <td>{{ $numberFormat(totals.totalCost) }}</td>
                                <td>{{ $t('sumPayment') }}</td>
                                <td>{{ $numberFormat(totalPayment) }}</td>
                              </tr>
                              <tr>
                                <td colspan="2">
                                  {{ $t('remain') }}
                                </td>
                                <td colspan="2">
                                  {{ $numberFormat(+totals.totalCost - +totalPayment) }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="e1 > 2 && !id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="e1 > 2 && id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="e1 < 3"
              color="green"
              class="mr-0"
              :loading="isLoading"
              @click="e1++"
            >
              {{ $t('continue') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @get="setRecieve"
      @close="innerComponent = false"
    />
  </v-card>
</template>

<script>
  import aicomplete from '../../components/general/AIcomplete/index'
  import autocomplete from '../../components/general/patial/autocomplete'
  import General from '../../../../Mixins/general'
  import Description from '../../components/general/description/Description'
  import OrderItem from './partial/orderItem'
  export default {
    name: 'TranslateOrder',
    components: {
      aicomplete,
      Description,
      autocomplete,
      OrderItem,
      dialogComponent: () => import('../../components/general/dialog/index'),
      Status: () => import('../../components/general/Status/status'),
      Tag: () => import('../../components/general/Tag/tag'),
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      exampleRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      snakbar: false,
      render: false,
      isLoading: false,
      dialogData: null,
      alert: false,
      e1: 1,
      translator: null,
      embassyName: null,
      discountService: 0,
      discountTranslate: 0,
      unofficial: null,
      embassy: null,
      embassyCost: null,
      embassyCount: 0,
      embassyPrice: 0,
      equalOriginal: null,
      equalOriginalCount: 0,
      equalOriginalPrice: 0,
      verificationServices: null,
      verificationServicesCount: 0,
      verificationServicesPrice: 0,
      officeServices: null,
      officeServicesCount: 0,
      officeServicesPrice: 0,
      stampTranslator: null,
      stampTranslatorCount: 0,
      stampTranslatorPrice: 0,
      judicialApproval: null,
      judicialApprovalCount: 0,
      judicialApprovalPrice: 0,
      foreignApproval: null,
      foreignApprovalCount: 0,
      foreignApprovalPrice: 0,
      specialTranslatPrice: 0,
      otherPrice: 0,
      date: null,
      countSpecialTranslatAdditional: 0,
      percentDocumentCount: 50,
      countSpecialTranslat: 0,
      urgentAmount: 0,
      addDocumentCount: 0,
      baseCount: 0,
      basePrice: 0,
      customerTitle: null,
      customertContent: null,
      documentCount: null,
      toLanguage: null,
      fromLanguage: null,
      documentType: null,
      documentOwner: null,
      deliveryDate: null,
      languageGroup: null,
      from: null,
      tag: null,
      nontranslateDocument: null,
      nontranslateDocumentContent: null,
      nontranslateDocumentItems: [],
      number: 1,
      content: null,
      valid: null,
      validStep2: null,
      validStep3: null,
      message: null,
      alertType: null,
      customer: null,
      type: null,
      id: null,
      items: [],
      status: null,
      editIndex: null,
      editStatus: false,
      group: null,
      recieves: [],
      checks: [],
      sum: null,
      priceChange: true,
      loading: false,
      loadingEqualOriginal: false,
    }),
    computed: {
      approvalRules () {
        return [
          v => (v && v >= 0) || 'The number must be bigger than zero',
        ]
      },
      totalStamp () {
        var total = 0
        var foreignApprovalPrice = this.foreignApprovalPrice * this.foreignApprovalCount
        var embassyPrice = this.embassyPrice * this.embassyCount
        var verificationServicesPrice = this.verificationServicesPrice * this.verificationServicesCount
        var equalOriginalPrice = this.equalOriginalPrice * this.equalOriginalCount
        var officeServicesPrice = this.officeServicesPrice * this.officeServicesCount
        var judicialApprovalPrice = this.judicialApprovalPrice * this.judicialApprovalCount
        var stampTranslatorPrice = this.stampTranslatorPrice * this.stampTranslatorCount
        total = foreignApprovalPrice + embassyPrice + verificationServicesPrice + equalOriginalPrice + stampTranslatorPrice + judicialApprovalPrice + officeServicesPrice
        return total
      },
      totalCost () {
        var total = 0
        total = parseFloat(this.basePriceTotal) + parseFloat(this.addDocumentPriceTotal) +
          parseFloat(this.specialTranslatTotal) +
          parseFloat(this.specialTranslatAddPriceTotal) + parseFloat(this.totalStamp) + parseFloat(this.urgentAmount) - parseFloat(this.discountTranslate) - parseFloat(this.discountService)
        return total
      },
      basePriceTotal () {
        var total = 0
        if (this.basePrice && this.baseCount) {
          total = this.basePrice * this.baseCount
        }
        return total
      },
      addDocumentPrice () {
        var price = 0
        if (this.basePrice && this.addDocumentCount && this.percentDocumentCount) {
          price = (parseFloat(this.percentDocumentCount) / 100) * parseFloat(this.basePrice)
        }
        return price
      },
      addDocumentPriceTotal () {
        var total = 0
        if (this.addDocumentPrice && this.addDocumentCount) {
          total = this.addDocumentPrice * this.addDocumentCount
        }
        return total
      },
      specialTranslatTotal () {
        var total = 0
        if (this.specialTranslatPrice && this.countSpecialTranslat) {
          total = this.specialTranslatPrice * this.countSpecialTranslat
        }
        return total
      },
      specialTranslatAddPrice () {
        var price = 0
        if (this.basePrice && this.specialTranslatPrice && this.percentDocumentCount) {
          price = (parseFloat(this.percentDocumentCount) / 100) * parseFloat(this.specialTranslatPrice)
        }
        return price
      },
      specialTranslatAddPriceTotal () {
        var price = 0
        if (this.basePrice && this.specialTranslatAddPrice && this.countSpecialTranslatAdditional) {
          price = this.specialTranslatAddPrice * this.countSpecialTranslatAdditional
        }
        return price
      },
      totalPayment () {
        var cash = 0
        var check = 0
        this.recieves.map(function (value, index) {
          cash = +cash + +value.amount
        })
        this.checks.map(function (value, index) {
          check = +check + +value.amount
        })
        return +cash + +check
      },
      totals: function () {
        var basePriceTotal = 0
        var addDocumentPriceTotal = 0
        var specialTranslatTotal = 0
        var specialTranslatAddPriceTotal = 0
        var urgentAmount = 0
        var stampTranslatorPrice = 0
        var judicialApprovalPrice = 0
        var officeServicesPrice = 0
        var equalOriginalPrice = 0
        var foreignApprovalPrice = 0
        var verificationServicesPrice = 0
        var embassyPrice = 0
        var discountService = 0
        var discountTranslate = 0
        var totalCost = 0
        this.items.map((value, d) => {
          basePriceTotal += parseFloat(value.basePriceTotal)
          addDocumentPriceTotal += parseFloat(value.addDocumentPriceTotal)
          specialTranslatTotal += parseFloat(value.specialTranslatTotal)
          specialTranslatAddPriceTotal += parseFloat(value.specialTranslatAddPriceTotal)
          urgentAmount += parseFloat(value.urgentAmount)
          stampTranslatorPrice += parseFloat(value.stampTranslatorPrice * value.stampTranslatorCount)
          judicialApprovalPrice += parseFloat(value.judicialApprovalPrice * value.judicialApprovalCount)
          officeServicesPrice += parseFloat(value.officeServicesPrice * value.officeServicesCount)
          equalOriginalPrice += parseFloat(value.equalOriginalPrice * value.equalOriginalCount)
          foreignApprovalPrice += parseFloat(value.foreignApprovalPrice * value.foreignApprovalCount)
          verificationServicesPrice += parseFloat(value.verificationServicesPrice * value.verificationServicesCount)
          embassyPrice += parseFloat(value.embassyPrice * value.embassyCount)
          discountService += parseFloat(value.discountService)
          discountTranslate += parseFloat(value.discountTranslate)
          totalCost += parseFloat(value.totalCost)
        })
        var total = {
          basePriceTotal: basePriceTotal,
          addDocumentPriceTotal: addDocumentPriceTotal,
          specialTranslatTotal: specialTranslatTotal,
          specialTranslatAddPriceTotal: specialTranslatAddPriceTotal,
          urgentAmount: urgentAmount,
          stampTranslatorPrice: stampTranslatorPrice,
          officeServicesPrice: officeServicesPrice,
          judicialApprovalPrice: judicialApprovalPrice,
          equalOriginalPrice: equalOriginalPrice,
          foreignApprovalPrice: foreignApprovalPrice,
          embassyPrice: embassyPrice,
          verificationServicesPrice: verificationServicesPrice,
          discountService: discountService,
          discountTranslate: discountTranslate,
          totalCost: totalCost,
        }
        return total
      },
    },
    watch: {
      unofficial (val, oldVal) {
        if (val) {
          this.officeServices = 'active'
          // this.officeServicesCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        }
      },
      judicialApproval (val, oldVal) {
        if (val) {
          this.judicialApprovalCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.judicialApprovalCount = 0
        }
      },
      foreignApproval (val, oldVal) {
        if (val) {
          this.foreignApprovalCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.foreignApprovalCount = 0
        }
      },
      stampTranslator (val, oldVal) {
        if (val) {
          this.stampTranslatorCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.stampTranslatorCount = 0
        }
      },
      officeServices (val, oldVal) {
        if (val) {
          this.officeServicesCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.officeServicesCount = 0
        }
      },
      verificationServices (val, oldVal) {
        if (val) {
          this.verificationServicesCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.verificationServicesCount = 0
        }
      },
      equalOriginal (val, oldVal) {
        if (!this.loadingEqualOriginal) {
          if (val) {
            this.equalOriginalCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
          } else {
            this.equalOriginalCount = 0
          }
          this.loadingEqualOriginal = false
        }
      },
      embassy (val, oldVal) {
        if (val) {
          this.embassyCount = parseFloat(this.baseCount) + parseFloat(this.addDocumentCount)
        } else {
          this.embassyCount = 0
        }
      },
      snakbar () {
      },
      toLanguage (val, oldVal) {
        if (val && this.fromLanguage && this.documentType && this.priceChange) {
          this.getPrice()
        }
        this.priceChange = true
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.getTranslatorNumber()
      }
    },
    mounted () {
    },
    methods: {
      getTranslatorNumber () {
        this.loading = true
        var app = this
        app.isLoading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              select: 'getTranslatorNumber',
            },
          })
            .then(res => {
              res = res.data
              if (res.status === 'error') {
                if (app.checkNumber) {
                  app.snakbarText = res.message
                  app.snakbarColor = 'pink'
                  app.snakbar = true
                }
                app.number = res.number
              }
              app.checkNumber = true
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 50)
        this.loading = false
      },
      setRecieve (data) {
        if (data.type === 'recieve') {
          this.recieves.push(data)
        }
        if (data.type === 'recieveCheck') {
          this.checks.push(data)
        }
      },
      removeCash (index) {
        var item = this.recieves[index]
        var app = this
        if (item.id) {
          app.loading = true
          app.$axios.delete(this.$endpoint + 'payments/' + item.id)
            .then(res => {
              res = res.data
              app.recieves.splice(index, 1)
            })
            .finally(() => (app.loading = false))
        } else {
          app.recieves.splice(index, 1)
        }
      },
      removeCheck (index) {
        var item = this.checks[index]
        var app = this
        if (item.id) {
          app.loading = true
          app.$axios.delete(this.$endpoint + 'checks/' + item.id)
            .then(res => {
              res = res.data
              app.checks.splice(index, 1)
            })
            .finally(() => (app.loading = false))
        } else {
          app.checks.splice(index, 1)
        }
      },
      openComponent (component, account, type) {
        this.dialogData = {
          name: component,
          accountProp: account,
          notStore: true,
          type: type,
        }
        this.innerComponent = true
      },
      addItem () {
        if (!this.$refs.formStep2.validate()) return false
        var item = {
          documentType: this.documentType,
          fromLanguage: this.fromLanguage,
          toLanguage: this.toLanguage,
          customerTitle: this.customerTitle,
          customertContent: this.customertContent,
          documentCount: this.documentCount,
          baseCount: this.baseCount,
          basePrice: this.basePrice,
          addDocumentCount: this.addDocumentCount,
          percentDocumentCount: this.percentDocumentCount,
          countSpecialTranslat: this.countSpecialTranslat,
          countSpecialTranslatAdditional: this.countSpecialTranslatAdditional,
          unofficial: this.unofficial,
          judicialApproval: this.judicialApproval,
          judicialApprovalCount: this.judicialApprovalCount,
          judicialApprovalPrice: this.judicialApprovalPrice,
          foreignApproval: this.foreignApproval,
          foreignApprovalCount: this.foreignApprovalCount,
          foreignApprovalPrice: this.foreignApprovalPrice,
          stampTranslator: this.stampTranslator,
          stampTranslatorCount: this.stampTranslatorCount,
          stampTranslatorPrice: this.stampTranslatorPrice,
          officeServices: this.officeServices,
          officeServicesCount: this.officeServicesCount,
          officeServicesPrice: this.officeServicesPrice,
          verificationServices: this.verificationServices,
          verificationServicesCount: this.verificationServicesCount,
          verificationServicesPrice: this.verificationServicesPrice,
          equalOriginal: this.equalOriginal,
          equalOriginalCount: this.equalOriginalCount,
          equalOriginalPrice: this.equalOriginalPrice,
          embassy: this.embassy,
          embassyCount: this.embassyCount,
          embassyPrice: this.embassyPrice,
          embassyName: this.embassyName,
          embassyCost: this.embassyCost,
          urgentAmount: this.urgentAmount,
          discountService: this.discountService,
          discountTranslate: this.discountTranslate,
          basePriceTotal: this.basePriceTotal,
          addDocumentPriceTotal: this.addDocumentPriceTotal,
          specialTranslatTotal: this.specialTranslatTotal,
          specialTranslatAddPriceTotal: this.specialTranslatAddPriceTotal,
          totalCost: this.totalCost,
        }
        if (this.editStatus) {
          this.removeItem(this.editIndex)
        }
        this.items.push(item)
        // this.$refs.formStep2.reset()
        this.clear()
        this.$refs.formStep2.resetValidation()
      },
      getPrice () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'translation/show', {
          params: {
            getPrice: 'yes',
            type: (app.documentType ? app.documentType.id : null),
            fromLang: (app.fromLanguage ? app.fromLanguage.id : null),
            toLang: (app.toLanguage ? app.toLanguage.id : null),
            userCategory: (app.toLanguage ? app.toLanguage.id : null),
          },
        })
          .then(res => {
            res = res.data
            app.basePrice = res.fee
            app.equalOriginalPrice = res.equal_original
            app.verificationServicesPrice = res.verification_services
            app.officeServicesPrice = res.office_services
            app.stampTranslatorPrice = res.stamp_translator
            app.judicialApprovalPrice = res.judicial_approval
            app.foreignApprovalPrice = res.foreign_approval
            app.embassyPrice = res.embassy
            app.specialTranslatPrice = res.special_translation
            app.otherPrice = res.other
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      addAttachment () {
        this.nontranslateDocumentItems.push({
          nontranslateDocument: this.nontranslateDocument,
          documentOwner: this.documentOwner,
          content: this.nontranslateDocumentContent,
        })
        this.nontranslateDocument = null
        this.nontranslateDocumentContent = null
      },
      removeAttachment (key) {
        this.nontranslateDocumentItems.splice(key, 1)
      },
      create () {
        var app = this
        app.isLoading = true
        app.sum = app.totals
        app.$axios.post(this.$endpoint + 'translation', app.$data)
          .then(res => {
            app.goTo('translationList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'translation/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.customer = res.customer
              app.translator = res.translator
              app.status = (res.status ? res.status.status : null)
              app.tag = res.tags
              app.number = res.number
              app.date = res.date
              app.checks = res.check
              app.recieves = res.payment
              app.deliveryDate = res.delivery_date
              app.nontranslateDocumentItems = res.nontranslateDocumentItems
              app.items = res.article
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.sum = app.totals
        app.$axios.put(this.$endpoint + 'translation/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.goTo('translationList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      removeItem (index) {
        this.items.splice(index, 1)
      },
      editItem (item, index) {
        this.priceChange = false
        this.editIndex = index
        this.editStatus = true
        this.documentType = item.documentType
        this.fromLanguage = item.fromLanguage
        this.toLanguage = item.toLanguage
        this.customerTitle = item.customerTitle
        this.customertContent = item.customertContent
        this.documentCount = item.documentCount
        this.baseCount = item.baseCount
        this.basePrice = item.basePrice
        this.addDocumentCount = item.addDocumentCount
        this.percentDocumentCount = item.percentDocumentCount
        this.countSpecialTranslat = item.countSpecialTranslat
        this.countSpecialTranslatAdditional = item.countSpecialTranslatAdditional
        this.unofficial = item.unofficial
        this.judicialApproval = item.judicialApproval
        this.judicialApprovalCount = item.judicialApprovalCount
        this.judicialApprovalPrice = item.judicialApprovalPrice
        this.foreignApproval = item.foreignApproval
        this.foreignApprovalCount = item.foreignApprovalCount
        this.foreignApprovalPrice = item.foreignApprovalPrice
        this.stampTranslator = item.stampTranslator
        this.stampTranslatorCount = item.stampTranslatorCount
        this.stampTranslatorPrice = item.stampTranslatorPrice
        this.officeServices = item.officeServices
        this.officeServicesCount = item.officeServicesCount
        this.officeServicesPrice = item.officeServicesPrice
        this.verificationServices = item.verificationServices
        this.verificationServicesCount = item.verificationServicesCount
        this.verificationServicesPrice = item.verificationServicesPrice
        this.equalOriginal = item.equalOriginal
        this.equalOriginalCount = item.equalOriginalCount
        this.equalOriginalPrice = item.equalOriginalPrice
        this.embassy = item.embassy
        this.embassyCount = item.embassyCount
        this.embassyPrice = item.embassyPrice
        this.embassyName = item.embassyName
        this.embassyCost = item.embassyCost
        this.urgentAmount = item.urgentAmount
        this.discountService = item.discountService
        this.discountTranslate = item.discountTranslate
        this.loadingEqualOriginal = true
      },
      cashReceive () {

      },
      clear () {
        this.editStatus = false
        this.editIndex = null
        this.documentType = null
        this.fromLanguage = null
        this.toLanguage = null
        this.customerTitle = ''
        this.customertContent = ''
        this.documentCount = 0
        this.baseCount = 0
        this.basePrice = null
        this.addDocumentCount = 0
        this.percentDocumentCount = 50
        this.countSpecialTranslat = 0
        this.countSpecialTranslatAdditional = 0
        this.unofficial = null
        this.judicialApproval = null
        this.judicialApprovalCount = 0
        this.judicialApprovalPrice = null
        this.foreignApproval = null
        this.foreignApprovalCount = 0
        this.foreignApprovalPrice = null
        this.stampTranslator = null
        this.stampTranslatorCount = 0
        this.stampTranslatorPrice = null
        this.officeServices = null
        this.officeServicesCount = 0
        this.officeServicesPrice = null
        this.verificationServices = null
        this.verificationServicesCount = 0
        this.verificationServicesPrice = null
        this.equalOriginal = null
        this.equalOriginalCount = 0
        this.equalOriginalPrice = null
        this.embassy = null
        this.embassyCount = null
        this.embassyPrice = null
        this.embassyName = null
        this.embassyCost = null
        this.urgentAmount = 0
        this.discountService = 0
        this.discountTranslate = 0
      },
    },
  }
</script>

<style scoped>
.invoice-1 {
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background-color: azure;
}
.invoice-2 {
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background-color: #fdfdc6;
}
.invoice-3 {
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background-color: #c6f5fd;
}
.invoice-discount {
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  background-color: #fdc6d9;
}
.v-label.v-label, .v-alert.v-alert {
  font-size: 11px !important;
}
.v-stepper__step{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
</style>
